import { gql } from "@apollo/client";

export const FOLDER_EXTERNAL_CHECKS = gql`
  query folderExternalCheckList($documentId: Int!, $siteId: Int!) {
    folderExternalCheckList(documentId: $documentId, siteId: $siteId) {
      offerId
      offerSiteId
      documentVerificationId
      verificationName
      entityType
      entityName
      result
    }
  }
`;
